var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24596 8.35866C6.88138 8.35866 6.5931 8.64199 6.5931 9.00033C6.5931 9.35033 6.88138 9.64199 7.24596 9.64199H12.3332V13.6253C12.3332 15.667 10.6459 17.3337 8.56016 17.3337H4.43104C2.35376 17.3337 0.666504 15.6753 0.666504 13.6337V4.37533C0.666504 2.32533 2.36224 0.666992 4.43952 0.666992H8.57712C10.6459 0.666992 12.3332 2.32533 12.3332 4.36699V8.35866H7.24596ZM15.3584 6.11716L17.7917 8.54216C17.9167 8.66716 17.9834 8.8255 17.9834 9.0005C17.9834 9.16716 17.9167 9.33383 17.7917 9.4505L15.3584 11.8755C15.2334 12.0005 15.0667 12.0672 14.9084 12.0672C14.7417 12.0672 14.575 12.0005 14.45 11.8755C14.2 11.6255 14.2 11.2172 14.45 10.9672L15.7834 9.64216H12.3334V8.35883H15.7834L14.45 7.03383C14.2 6.78383 14.2 6.3755 14.45 6.1255C14.7 5.86716 15.1084 5.86716 15.3584 6.11716Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.102cff41b9f8ca201a421a7558138d51.svg";
export { ForwardRef as ReactComponent };